import { CheckOutlined, CloseOutlined, DeleteOutlined, PlusOutlined, SaveOutlined, UploadOutlined } from '@ant-design/icons';
import ModalTextForm from '@app/components/modal/ModalTextForm';
import { Button, Col, DatePicker, Form, Input, Row, Switch, Table, Tabs, Upload } from 'antd';
import Column from 'antd/es/table/Column';
import viVN from 'antd/lib/date-picker/locale/vi_VN';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import type { UploadFile, UploadProps } from 'antd/es/upload/interface';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ContentHeader } from "../../components";
import DanhSachNhanVienTheoDonViTableModal from "../../components/modal/DanhSachNhanVienTheoDonViTableModal";
import { arrayCommon, dateCommon, validateMessages } from "../../helpers/common";
import { NhanVienTheoToBan, ToBan, ToBanRequest } from "../../models/toban/ToBan";
import { layChiTiet, luuToBan } from "../../services/toban";
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import { TaiLieu } from '../../models/nhanvien/TaiLieu';
import { urlAdmin } from '../../constants';
import { Links } from '../../helpers/Links';

const ChiTietToBan = () => {
    const params = new URLSearchParams(window.location.search);

    const [stateHD, setStateHD] = useState<boolean>(false);
    let id = params.get('id') || '0';
    let navigate = useNavigate();
    const { TextArea } = Input;
    const [form] = Form.useForm();
    const [themMoi, setThemMoi] = useState(true);
    const [title, setTitle] = useState("Thêm mới tổ ban");
    const [openModalLuu, setOpenModalLuu] = useState(false);
    const [data, setData] = useState<ToBan>(new ToBan);
    const [dsNhanVien, setDsNhanVien] = useState<Array<NhanVienTheoToBan>>([]);
    const [showModalDSNV, setShowModalDSNV] = useState(false);
    const dispatch = useDispatch();
    const [idsTaiLieuToBanXoa, setIdsTaiLieuToBanXoa] = useState<Array<number>>([]);

    const [fileList, setFileList] = useState<UploadFile[]>([]);
    const props: UploadProps = {
        onRemove: (file) => {
            if (file.uid.includes("tailieu")) {
                var id = parseInt(file.uid.split("tailieu")[0]);
                setIdsTaiLieuToBanXoa([...idsTaiLieuToBanXoa, id]);
            }
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
        },
        beforeUpload: (file) => {
            const maxSize = 20000000; // 20 MB
            if (file.size > maxSize) {
                alert('Tệp tin đính kèm không được vượt quá 20MB');
            } else {
                setFileList([...fileList, file]);
            }
            return false;
        },
        fileList,
    };

    const submitLuu = async (value: any) => {
        try {
            var dsNhanVien = (value.dsNhanVien || []).map((x: any) => ({
                idNhanVien: x.idNhanVien,
                chucDanh: x.chucDanh
            }));
            var ngayBatDau = dateCommon.formatDate(value.ngayBatDau?.$d);
            var ngayKetThuc = dateCommon.formatDate(value?.ngayKetThuc?.$d);
            var ngayKyQuyetDinh = dateCommon.formatDate(value.ngayKyQuyetDinh?.$d);
            var request: ToBanRequest = {
                files: fileList,
                id: value.id || null,
                ten: value.ten,
                soQuyetDinh: value.soQuyetDinh,
                ngayKyQuyetDinh: ngayKyQuyetDinh,
                ngayBatDau: ngayBatDau,
                ngayKetThuc: ngayKetThuc,
                dsNhanVien: dsNhanVien,
                trangThai: value.trangThai || 0,
                moTa: value.moTa,
                idsTaiLieuToBanXoa: idsTaiLieuToBanXoa
            }
            dispatch(showLoadingScreen());
            var id = await luuToBan(request);
            setOpenModalLuu(false);
            dispatch(showLoadingScreen());
            if (themMoi) {
                toast.success('Tạo mới tổ ban thành công!');
                navigate(Links.ToBan.Xem + "?id=" + id);
            } else {
                toast.success('Cập nhật tổ ban thành công!');
            }
            dispatch(hideLoadingScreen());
        }
        catch (error: any) {
            dispatch(hideLoadingScreen());
            setOpenModalLuu(false);
            toast.error(error.message || "Vui lòng thử lại");
        };
    };

    const layCT = async (id: number) => {
        dispatch(showLoadingScreen());
        try {
            var data = await layChiTiet(id);
            if (data.id > 0) {
                form.setFieldsValue({
                    id: data?.id,
                    ten: data?.ten,
                    moTa: data?.moTa,
                    soQuyetDinh: data?.soQuyetDinh,
                    trangThai: data?.trangThai,
                    ngayKyQuyetDinh: data?.ngayKyQuyetDinh ? dayjs(dateCommon.formatDate(data?.ngayKyQuyetDinh), "DD/MM/YYYY") : null,
                    ngayBatDau: data?.ngayBatDau ? dayjs(dateCommon.formatDate(data?.ngayBatDau), "DD/MM/YYYY") : null,
                    ngayKetThuc: data?.ngayKetThuc ? dayjs(dateCommon.formatDate(data?.ngayKetThuc), "DD/MM/YYYY") : null
                });
                setStateHD(data?.trangThai == 1 ? true : false);
                var fileHienTai: any = (data?.dsTaiLieu || []).map((item: TaiLieu) => {
                    return {
                        uid: item.idTaiLieu + "tailieu",
                        name: item.tenTep,
                        status: 'done',
                        url: urlAdmin + item.duongDan.replace(/\\/g, "/"),
                        //url: item.duongDan.replace("View\\public", urlAdmin).replace(/\\/g, "/"),
                    };
                });
                setFileList(fileHienTai);
                setDsNhanVien(data.dsNhanVien);
                setTitle("Chi tiết tổ ban");
                setThemMoi(false);
            }
        } catch (error: any) {
            toast.error("Tổ ban không tồn tại!");
        }
        dispatch(hideLoadingScreen());
    }

    const onChangeDanhSachNhanVienTableModal = (data: NhanVienTheoToBan, isChecked: boolean) => {
        setDsNhanVien(prev => {
            var tempData = [...prev];
            var isExists = arrayCommon.isExisted(tempData.map(x => x.idNhanVien), data.idNhanVien);
            if (isChecked && !isExists) {
                tempData.push(data);
            }
            if (!isChecked && isExists) {
                var index = tempData.map(x => x.idNhanVien).indexOf(data.idNhanVien);
                if (index > -1) {
                    tempData.splice(index, 1);
                }
            }
            return tempData;
        });
    }

    const onFinish = (values: any) => {
        var saveData: ToBan = {
            "id": parseInt(id),
            "ten": values.ten || "",
            "moTa": values.moTa || "",
            "soQuyetDinh": values.soQuyetDinh || "",
            "trangThai": values.trangThai || 0,
            "ngayKyQuyetDinh": values.ngayKyQuyetDinh,
            "ngayBatDau": values.ngayBatDau,
            "ngayKetThuc": values.ngayKetThuc,
            "dsNhanVien": dsNhanVien,
            dsTaiLieu: []
        };
        setData(saveData);
        setOpenModalLuu(true);
    };

    useEffect(() => {
        if (parseInt(id) > 0) {
            layCT(parseInt(id));
        }
    }, []);

    return (
        <>
            <ContentHeader title={title} />
            {
                openModalLuu && <ModalTextForm show={openModalLuu}
                    title={!themMoi ? "Cập nhật tổ ban" : "Thêm mới tổ ban"}
                    handleClose={() => setOpenModalLuu(false)}
                    handleSave={() => submitLuu(data)}>
                    Bạn có muốn {!themMoi ? "cập nhật tổ ban" : "tạo mới tổ ban"} không?
                </ModalTextForm>
            }
            <section className="content" style={{ paddingBottom: "47px" }}>
                <Row>
                    <Col span={24}>
                        <Form layout="vertical" onFinish={onFinish} validateMessages={validateMessages} form={form}>
                            <Tabs defaultActiveKey="1" items={[
                                {
                                    key: '1',
                                    label: 'Thông tin chung',
                                    children:
                                        <div className="card pt-3 pb-2">
                                            <div className="tab-content pl-3 pr-3">
                                                <Row gutter={16}>
                                                    <Col span={8} >
                                                        <Form.Item name="ten" label="Tên tổ ban"
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                }
                                                            ]}>
                                                            <Input placeholder="Tên tổ ban" />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={8}>
                                                        <Form.Item name="soQuyetDinh" label="Số quyết định">
                                                            <Input placeholder="Số quyết định" />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={8}>
                                                        <Form.Item
                                                            name="ngayKyQuyetDinh"
                                                            label="Ngày ký quyết định">
                                                            <DatePicker changeOnBlur={true} style={{ width: "100%" }} placeholder="Ngày ký quyết định" format={["DD/MM/YYYY", "DDMMYYYY"]} locale={viVN} />
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                                <Row gutter={16}>
                                                    <Col span={8}>
                                                        <Form.Item
                                                            name="ngayBatDau"
                                                            label="Ngày bắt đầu">
                                                            <DatePicker changeOnBlur={true} style={{ width: "100%" }} placeholder="Ngày bắt đầu" format={["DD/MM/YYYY", "DDMMYYYY"]} locale={viVN} />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={8}>
                                                        <Form.Item
                                                            name="ngayKetThuc"
                                                            label="Ngày kết thúc">
                                                            <DatePicker changeOnBlur={true} style={{ width: "100%" }} placeholder="Ngày kết thúc" format={["DD/MM/YYYY", "DDMMYYYY"]} locale={viVN} />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={8}>
                                                        <Form.Item name="trangThai" label="Trạng thái">
                                                            <>
                                                                <Switch checked={stateHD} checkedChildren={<CheckOutlined rev="" />} unCheckedChildren={<CloseOutlined rev="" />} onChange={(e) => { setStateHD(e); form.setFieldsValue({ trangThai: e === true ? 1 : 0 }) }} />
                                                            </>
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col span={24}>
                                                        <Form.Item name="moTa" label="Mô tả">
                                                            <TextArea rows={3} />
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col span="24">
                                                        <Upload {...props}>
                                                            <Button icon={<UploadOutlined rev="" />}>Thêm file</Button>
                                                        </Upload>
                                                    </Col>
                                                </Row>
                                                <Form.Item style={{ marginBottom: "0px" }}>
                                                    <Button style={{ position: "fixed", zIndex: 1, right: "24px", bottom: "70px" }} type="primary" className="float-right" htmlType="submit" icon=<SaveOutlined rev="" />>
                                                        Lưu
                                                    </Button>
                                                </Form.Item>
                                            </div>
                                        </div>
                                },
                            ]}>
                            </Tabs>
                        </Form>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <div className="card-outline">
                                <Tabs
                                    tabBarExtraContent=
                                    {
                                        <Button className="hrm-btn hrm-btn-warning"
                                            onClick={() => { setShowModalDSNV(true); }}
                                            icon={<PlusOutlined rev="" />}
                                        >
                                            Thêm mới
                                        </Button>
                                    }
                                    defaultActiveKey="1" items={[
                                        {
                                            key: '1',
                                            label: 'Danh sách nhân viên',
                                            children:
                                                <Table
                                                    locale={{ emptyText: "Không có dữ liệu" }}
                                                    dataSource={dsNhanVien}
                                                    pagination={false}
                                                    rowKey="id"
                                                >
                                                    <Column
                                                        title="STT"
                                                        key="STT"
                                                        render={(value, record, index) =>
                                                        (
                                                            <>
                                                                {index + 1}
                                                            </>
                                                        )
                                                        }
                                                    />
                                                    <Column title="Tên nhân viên" dataIndex="hoTen" key="hoTen" />
                                                    <Column title="Chức vụ" dataIndex="tenChucVu" key="tenChucVu" />
                                                    <Column title="Phòng ban" dataIndex="tenDonVi" key="tenDonVi" />
                                                    <Column title="Chức danh"
                                                        key="chucDanh"
                                                        render={(value: NhanVienTheoToBan, record, index) => (
                                                            <Input value={value.chucDanh}
                                                                key={index}
                                                                    onChange={(e) => {
                                                                        const newDataArray = [...dsNhanVien];
                                                                        newDataArray[index].chucDanh = e.target.value || "";
                                                                        setDsNhanVien(newDataArray);
                                                                    } }
                                                                />
                                                        )
                                                        }
                                                    />
                                                    <Column className="text-center"
                                                        title="Hành động"
                                                        key="action"
                                                        render={(value: NhanVienTheoToBan, record, index) => {
                                                            return (
                                                                <Button type="primary" key={index}
                                                                    icon=<DeleteOutlined rev="" />
                                                                    size={"small"}
                                                                    danger
                                                                    onClick={() => {
                                                                        onChangeDanhSachNhanVienTableModal(value, false);
                                                                    }}>Xóa</Button>
                                                            )
                                                        }}
                                                    />
                                                </Table>
                                        },
                                    ]}>
                                </Tabs>
                        </div>
                    </Col>
                </Row>
            </section>
            {showModalDSNV ? <DanhSachNhanVienTheoDonViTableModal checklist={dsNhanVien} hide={() => setShowModalDSNV(false)} onChange={onChangeDanhSachNhanVienTableModal} idLopDaoTao={parseInt(id)} /> : null}

        </>
    )
}

export default ChiTietToBan;